export default __webpack_public_path__ + "static/media/036-rainy.87813b14.svg";